import React from "react";
import { observer } from "mobx-react";
import { AlertSubscriptionCreateStore } from "../../store";
import { AlertSubscriptionCreateForm } from "./AlertSubscriptionCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type AlertSubscriptionCreateProps = {
  alertSubscriptionCreateStore: AlertSubscriptionCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AlertSubscriptionCreate: React.FC<AlertSubscriptionCreateProps> =
  observer(
    ({ alertSubscriptionCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={alertSubscriptionCreateStore.isSaving} />
          <AlertSubscriptionCreateForm
            alertSubscriptionCreateStore={alertSubscriptionCreateStore}
            alertRuleError={
              alertSubscriptionCreateStore.errors.alertRule?.message
            }
            onAlertRuleChange={(value) => {
              alertSubscriptionCreateStore.setAlertRuleValue(value);
            }}
            alertRuleSelectedValue={
              alertSubscriptionCreateStore.entityValues.showAlertRule
            }
            onAlertRuleSelected={(value) => {
              alertSubscriptionCreateStore.setSelectedAlertRule(value);
            }}
            alertRuleOptions={alertSubscriptionCreateStore.getAlertRuleOptions()}
            enabledError={alertSubscriptionCreateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              alertSubscriptionCreateStore.setEnabledValue(value);
            }}
            enabled={alertSubscriptionCreateStore.entityValues.enabled}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={alertSubscriptionCreateStore.isProcessing}
            onSave={() =>
              alertSubscriptionCreateStore.saveNewAlertSubscription()
            }
            onCancel={() =>
              alertSubscriptionCreateStore.cancelNewAlertSubscription()
            }
          />
          <ErrorDialog
            open={alertSubscriptionCreateStore.errorDialogOpened}
            title={alertSubscriptionCreateStore.errorTitle}
            description={alertSubscriptionCreateStore.errorDescription}
            onClose={() => alertSubscriptionCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
